import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, FileStack, Inbox, ArrowLeftRight, ScrollText, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const links = [
  { to: "/sbt-panel-7391", end: true, label: "Dashboard", icon: LayoutDashboard },
  { to: "/sbt-panel-7391/entities", label: "Content", icon: FileStack },
  { to: "/sbt-panel-7391/leads", label: "Leads", icon: Inbox },
  { to: "/sbt-panel-7391/redirects", label: "Redirects", icon: ArrowLeftRight },
  { to: "/sbt-panel-7391/audit", label: "Audit Log", icon: ScrollText },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const doLogout = async () => { await logout(); navigate("/sbt-panel-7391/login"); };

  return (
    <div className="min-h-screen bg-obsidian flex" dir="ltr">
      <aside className="w-60 shrink-0 border-r border-white/10 bg-graphite flex flex-col">
        <div className="p-5 border-b border-white/10">
          <p className="font-display text-xl font-extrabold uppercase text-ink">Sıfır<span className="text-copper">Bir</span> CMS</p>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {links.map((l) => (
            <NavLink
              key={l.to} to={l.to} end={l.end}
              data-testid={`admin-nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${
                  isActive ? "bg-copper/15 text-copper" : "text-subtle hover:text-ink hover:bg-surface"
                }`}
            >
              <l.icon size={18} /> {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-white/10">
          <p className="text-xs text-faint px-3 mb-2 truncate">{user?.email}</p>
          <button data-testid="admin-logout" onClick={doLogout} className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-subtle hover:text-red-400 hover:bg-surface w-full transition-colors">
            <LogOut size={18} /> Logout
          </button>
        </div>
      </aside>
      <div className="flex-1 overflow-x-hidden">
        <div className="p-6 lg:p-8 max-w-6xl">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
